import styled from 'styled-components';
import {
  Radio,
} from 'antd';
import {
  COLOR_CV_6,
} from 'constants/colors';

export const StyledAntdRadio = styled(Radio)`
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: ${COLOR_CV_6};
  }

  .ant-radio-checked {
    &::after {
      border: 1px solid ${COLOR_CV_6};
    }

    & .ant-radio-inner {
      border-color: ${COLOR_CV_6};
      box-shadow: 0 0 0 3px ${COLOR_CV_6}08;

      &::after {
        background-color: ${COLOR_CV_6};
      }
    }
  }
`;
